import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";
import type { ApiResponse } from "./api-client.service";

import type {
  Airline,
  AirlineFilter,
  AirlineApiResponse,
  AirlinePayload,
} from "../types/airlines.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.airlines;

const failure = (error: unknown, fallback: string) => ({
  success: false,
  statusCode: 500,
  message: error instanceof Error ? error.message : fallback,
  resData: null,
});

export const airlinesService = {
  async list(filter: AirlineFilter): Promise<AirlineApiResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<AirlineApiResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load airlines0 list.") as unknown as AirlineApiResponse;
    }
  },

  async details(id: number | string): Promise<ApiResponse<Airline>> {
    try {
      return await apiClient<ApiResponse<Airline>>(endpoints.details(id), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load airlines0 details.") as unknown as ApiResponse<Airline>;
    }
  },

  async create(payload: AirlinePayload): Promise<ApiResponse<Airline>> {
    try {
      return await apiClient<ApiResponse<Airline>>(endpoints.create, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to create airlines0.") as unknown as ApiResponse<Airline>;
    }
  },

  async update(id: number | string, payload: Partial<AirlinePayload>): Promise<ApiResponse<Airline>> {
    try {
      return await apiClient<ApiResponse<Airline>>(endpoints.update(id), {
        method: "PATCH",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to update airlines0.") as unknown as ApiResponse<Airline>;
    }
  },

  async delete(id: number | string): Promise<ApiResponse<unknown>> {
    try {
      return await apiClient<ApiResponse<unknown>>(endpoints.delete(id), {
        method: "DELETE",
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to delete airlines0.") as unknown as ApiResponse<unknown>;
    }
  },
};
